export default __webpack_public_path__ + "static/media/BoltBlack.bd960367.svg";